import React from 'react';

import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl';

import { primitive } from 'styles/constants';

export type InvalidItemsDiagnosticsRow = {
  key: string;
  lineLabel: string;
  detail: string;
};

export type InvalidItemsDiagnosticsPanelProps = {
  daypartsContextLines: string[];
  productRows: InvalidItemsDiagnosticsRow[];
  offerRows: InvalidItemsDiagnosticsRow[];
  rewardRows: InvalidItemsDiagnosticsRow[];
};

export const InvalidItemsDiagnosticsPanel = ({
  daypartsContextLines,
  productRows,
  offerRows,
  rewardRows,
}: InvalidItemsDiagnosticsPanelProps) => {
  const hasAny = productRows.length > 0 || offerRows.length > 0 || rewardRows.length > 0;
  if (!hasAny) {
    return null;
  }

  const Block = ({
    sectionTitle,
    rows,
  }: {
    sectionTitle: string;
    rows: InvalidItemsDiagnosticsRow[];
  }) => {
    if (!rows.length) {
      return null;
    }
    return (
      <View style={styles.debugSection}>
        <Typography style={styles.debugSectionTitle}>{sectionTitle}</Typography>
        {rows.map(row => (
          <View key={row.key} style={styles.debugRow}>
            <Typography style={styles.debugLineLabel}>{row.lineLabel}</Typography>
            <Typography style={styles.debugDetail}>{row.detail}</Typography>
          </View>
        ))}
      </View>
    );
  };

  return (
    <View style={styles.debugPanel} testID="cart-invalid-items-diagnostics">
      <Typography style={styles.debugPanelTitle}>Internal: availability diagnostics</Typography>
      {daypartsContextLines.length > 0 ? (
        <View style={styles.debugSection} testID="cart-invalid-items-diagnostics-dayparts">
          <Typography style={styles.debugSectionTitle}>Dayparts context</Typography>
          {daypartsContextLines.map((line, index) => (
            <Typography key={`daypart-${index}`} style={styles.debugDetail}>
              {line}
            </Typography>
          ))}
        </View>
      ) : null}
      <Block sectionTitle="Products" rows={productRows} />
      <Block sectionTitle="Offers" rows={offerRows} />
      <Block sectionTitle="Rewards" rows={rewardRows} />
    </View>
  );
};

const styles = StyleSheet.create({
  debugPanel: {
    marginTop: 20,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: primitive.$blackOpacity30,
    backgroundColor: primitive.$blackOpacity10,
  },
  debugPanelTitle: {
    fontSize: 12,
    fontWeight: '700',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.$bbqBrown,
    marginBottom: 10,
  },
  debugSection: {
    marginBottom: 12,
  },
  debugSectionTitle: {
    fontSize: 10,
    fontWeight: '600',
    textTransform: 'uppercase',
    fontFamily: primitive.fontFamily.$body,
    color: primitive.$blackOpacity70,
    marginBottom: 6,
  },
  debugRow: {
    marginBottom: 8,
  },
  debugLineLabel: {
    fontSize: 11,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.$bbqBrown,
    fontWeight: '600',
  },
  debugDetail: {
    fontSize: 10,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.$blackOpacity70,
    marginTop: 2,
  },
});
